@if (isModalPreview) {
  <div class="modal-backdrop d-flex justify-content-center align-items-center">
    <div class="modal-content p-5 text-center radius-12 bg-white position-relative" [ngClass]="{'max-width': isModalPreview}">
      @if (modalType === 'VERIFY_EMAIL') {
        <div class="head">
          <img class="text-center mb-3" src="assets/images/icons/email-verify-icon.png" alt="">
          <img src="assets/images/icons/cross-icon.svg" alt="" (click)="close()"
            class="position-absolute top-0 end-0 m-3 hw-30 cursor border rounded-circle p-1">
          </div>
          <div class="body">
            <h3 class="fs-24 fw-800 mb-3">Verify Your Email</h3>
            <p class="fs-16 fw-500 mb-3 text-color">{{userProfile.email_verified === 1 ? '':'We’ll send a secure verification link to'}}</p>
            <div class="mb-2 d-flex justify-content-between align-items-center rounded-pill mx-3 px-3 py-2"
              style="background-color: rgba(242, 247, 255, 1); border:1px solid rgba(206, 226, 255, 1);">
              <span class="fs-14 fw-700"
              style="color: rgba(0, 86, 216, 1); overflow: hidden;">{{userProfile.doctor_email}}</span>
              <img (click)="editEmail()" src="assets/images/icons/email-edit.png" height="12px" class="ms-2" alt="">
            </div>
            <img class="py-3" src="assets/images/icons/border-email.png" alt="">
            <p class="fs-16 fw-500 text-color">{{userProfile.email_verified === 1 ? 'Check your inbox and click the verification link to continue. If you don’t see the email, please check your spam or promotions folder. ':'Click the button below to receive the email and verify your account. '}} </p>
          </div>
          <div class="link-btn">
            @if (userProfile.email_verified === 1) {
              <button (click)="resendEmailLink()" class="fs-16 fw-700 btn btn-secondary px-3 py-3 mt-4">Resend Verification Link</button>
            }
            @if (userProfile.email_verified !== 1) {
              <button (click)="saveEmail()" class="fs-16 fw-700 btn btn-secondary px-3 py-3 mt-4">Send Verification Link</button>
            }
          </div>
        }
        @if (modalType === 'UPDATE_EMAIL') {
          <div class="head">
            <img class="text-center mb-3" src="assets/images/icons/email-verify-icon.png" alt="">
            <img src="assets/images/icons/cross-icon.svg" alt="" (click)="close()"
              class="position-absolute top-0 end-0 m-3 hw-30 cursor border rounded-circle p-1">
            </div>
            <div class="body">
              <h3 class="fs-24 fw-800 mb-3">Update Email</h3>
              <p class="fs-16 fw-500 mb-3 text-color">Enter a new email address to receive the verification link</p>
              <form [formGroup]="updateEmailForm">
                <div class="form-group mt-2">
                  <div class="custom-form">
                    <input type="text" class="input_field w-100" required maxlength="50" formControlName="doctor_email"
                      autocomplete="off" placeholder="Update Your Email" />
                    </div>
                    @if (updateEmailForm.get('doctor_email')?.touched && updateEmailForm.get('doctor_email')?.invalid) {
                      <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                        >
                        Please enter valid email address.
                      </p>
                    }
                  </div>
                </form>
                <button (click)="saveEmail()" [disabled]="updateEmailForm.invalid || updateEmailForm.get('doctor_email')?.value === userProfile.doctor_email"
                class="fs-16 fw-700 btn btn-secondary px-3 py-3 mt-4">Save & Send Link</button>
              </div>
            }
            @if (modalType === 'RESENT_EMAIL') {
              <div class="head">
                <img class="text-center mb-3" src="assets/images/icons/white-tick.png" alt="">
              </div>
              <div class="body">
                <h3 class="fs-24 fw-800 mb-3">{{userProfile.email_verified === 1 ? 'Verification Link Resent ':'Verification Link Send'}}</h3>
                <p class="fs-16 fw-500 mb-3 text-color">{{userProfile.email_verified === 1 ? 'We’ve just sent a fresh verification link to your email. Check your inbox or spam folder. ':'Check your inbox and click the verification link to continue. If you don’t see the email, please check your spam or promotions folder.'}}</p>
              </div>
            }
          </div>
        </div>
      }
      @if (!isModalPreview) {
        <div class="upfront-preview-static h-100 bg-white">
          <div class="px-4 py-3 bg-white w-100 border-bottom hw-65">
            <img src="assets/images/icons/back-arrow-circle.svg" class="hw-32 cursor" alt="" (click)="backToDashboard()">
          </div>
          <div class="h-100" style="max-height: calc(100% - 65px);">
            <div class="row h-100 m-0">
              <div class="col-12  col-xl-8 p-0 h-100 hide-scroll-bar overflow-auto">
                <div class="d-flex align-items-center justify-content-between p-3 upfront-header">
                  <div class="d-flex align-items-center">
                    <img src="assets/images/icons/bolt-icon-2.svg" class="me-2 hw-40" alt="">
                    <p class="fs-16 fw-800 m-0" style="color: rgba(214, 108, 2, 1);">Financing Offer</p>
                  </div>
                  <p class="fs-12 fw-600 grey-65 m-0">{{upfrontOffers.length}} Contracts Eligible</p>
                </div>
                <div class="p-3">
                  @if (upfrontOffers.length > 0) {
                    <div class="">
                      <div class="d-flex align-items-center justify-content-between border-bottom py-3 border-bottom mb-3">
                        <div>
                          <p class="fs-18 fw-500 grey-70 mb-2">
                            Remaining Share
                          </p>
                          <h4 class="fs-32 fw-700 black-44 m-0">
                            {{currency_data && currency_data.display_logo}}{{selectedPlansSummary.total_payout_amount | number:'1.2-2'}}
                          </h4>
                        </div>
                        <img src="assets/images/icons/right-arrow.png" class="mx-4 bg-white rounded-circle p-2 shadow" alt="">
                        <div>
                          <p class="fs-18 fw-500 grey-70 mb-2">
                            You‘ll Receive
                          </p>
                          <h4 class="fs-32 fw-700 text-green-offer m-0">
                            {{currency_data && currency_data.display_logo}}{{selectedPlansSummary.total_upfront_amount |
                            number:'1.2-2'}}
                          </h4>
                        </div>
                      </div>
                      <div class="py-3">
                        <div class="d-flex align-items-center justify-content-between">
                          <p class="fs-12 fw-700 m-0 grey-65">
                            Available Contracts to convert into financing payout.
                          </p>
                          <div>
                            <input type="checkbox" class="secondary-checkbox green-bg" [checked]="select_all_upfront"
                              (change)="toggleSelectAllUpfront($any($event.target).checked)" name="" id="modal_select_all_upfront">
                              <label for="modal_select_all_upfront">Select All</label>
                            </div>
                          </div>
                          <ul class="p-0 decoration-none mt-2 mb-0">
                            @for (offer of upfrontOffers; track offer) {
                              <li
                                class="d-flex align-items-center justify-content-between p-3 radius-8 mb-2 bg-white"
                                style="border: 1.5px solid rgba(233, 239, 232, 1)">
                                <div>
                                  <div class="mb-1">
                                    <input type="checkbox" class="secondary-checkbox green-bg" [checked]="offer.checked"
                                      (change)="toggleUpfrontContractSelection(offer.lo_id, $any($event.target).checked)" name=""
                                      [id]="'modal_upfront_contract_' + offer.contract_id">
                                      <label class="fs-18 fw-700 m-0 black-44" [for]="'modal_upfront_contract_' + offer.contract_id">{{currency_data
                                      && currency_data.display_logo}}{{(offer.available_share) | number:'1.2-2'}}</label>
                                    </div>
                                    <p class="fs-12 fw-600 m-0 grey-126" style="padding-left: 30px;">
                                      <span class="text-primary fs-14">{{offer.contract_code}}</span> <span
                                    class="hw-8 rounded-circle mx-1 d-inline-block" style="background: rgb(126 126 126 / 60%);"></span>
                                    Qualifying Payments <span class="fs-14 fw-700 black-44">{{offer.qualifying_payments}}</span>
                                  </p>
                                </div>
                                <div class="text-end">
                                  <p class="fs-18 fw-700 m-0 mb-2" style="color: rgba(19, 145, 69, 1);">
                                    {{currency_data && currency_data.display_logo}}{{offer.remaining_amount | number:'1.2-2'}}
                                  </p>
                                  <p class="fs-14 fw-00 m-0 grey-126">
                                    You’ll Receive
                                  </p>
                                </div>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    }
                    <div class="d-flex align-items-start mb-3">
                      <input type="checkbox" class="blue-checkbox" [(ngModel)]="isUpfrontConsentChecked" id="upfront_funding_term">
                      <label class="fs-13 fw-500 m-0 grey-65" for="upfront_funding_term">
                        I agree to receive an Financing and understand that an early access fee will apply.
                      </label>
                    </div>
                    <button class="btn btn-secondary fw-700" (click)="confirmAcceptOffer()">
                      Confirm & Get {{currency_data &&
                      currency_data.display_logo}}{{selectedPlansSummary.total_upfront_amount | number:'1.2-2'}}
                    </button>
                  </div>
                </div>
                <div class="col-12  col-xl-4 p-0 h-100 hide-scroll-bar overflow-auto">
                  <div class="bg-white h-100 d-flex flex-column justify-content-between p-4 ">
                    <div>
                      <div class="border-bottom pb-3 mb-4">
                        <h4 class="fs-20 fw-700 black-44 m-0">
                          Financing Payout Breakdown
                        </h4>
                      </div>
                      <div class="d-flex align-items-center justify-content-between border-bottom pb-3 mb-3">
                        <p class="fs-15 fw-500 grey-106 m-0">
                          Remaining Share
                        </p>
                        <p class="fs-16 fw-700 black-24 m-0">
                          {{currency_data && currency_data.display_logo}}{{selectedPlansSummary.total_payout_amount
                          | number:'1.2-2'}}
                        </p>
                      </div>
                      <div class="d-flex align-items-center justify-content-between border-bottom pb-3 mb-3">
                        <p class="fs-15 fw-500 grey-106 m-0">
                          Financing Fee
                        </p>
                        <p class="fs-16 fw-700 black-24 m-0">
                          -{{currency_data && currency_data.display_logo}}{{selectedPlansSummary.total_payout_amount
                          - selectedPlansSummary.total_upfront_amount | number:'1.2-2'}}
                        </p>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-4">
                        <p class="fs-22 fw-700 black-44 m-0">
                          You'll Receive
                        </p>
                        <p class="fs-22 fw-700 text-success m-0">
                          {{currency_data && currency_data.display_logo}}{{selectedPlansSummary.total_upfront_amount
                          | number:'1.2-2'}}
                        </p>
                      </div>
                      <div class="bg-light border rounded-4 p-3">
                        <div class="d-flex align-items-start mb-4">
                          <img src="assets/images/icons/green-shield.png" class="me-3" alt="">
                          <p class="fs-14 fw-700 black-44 m-0 mb-1">
                            No hidden charges.
                            <span class="fw-400 grey-106">
                              The fee shown is all you pay — no surprises.
                            </span>
                          </p>
                          <div>
                          </div>
                        </div>
                        <div class="d-flex align-items-start">
                          <img src="assets/images/icons/orange-clock.png" class="me-3" alt="">
                          <p class="fs-14 fw-700 black-44 m-0 mb-1">
                            Funds in next payout.
                            <span class="fw-400 grey-106">
                              You will receive the funds in your next upcoming payout.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="pt-4">
                      <div class="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-4">
                        <span class="badge bg-success bg-opacity-10 text-success px-3 py-2 fw-600">
                          Instant Cash Flow
                        </span>
                        <span class="badge bg-primary bg-opacity-10 text-primary px-3 py-2 fw-600">
                          Zero Risk
                        </span>
                        <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2 fw-600">
                          No Payment Delays
                        </span>
                      </div>
                      <p class="fs-15 fw-500 text-success m-0 d-flex align-items-center justify-content-center">
                        <i class="fa-solid fa-shield-halved me-2"></i>
                        Secured & verified by FinanceMutual<sup>TM</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <ng-template #CONFIRM_ACCEPT_OFFER>
          <div class="modal-content p-5 text-center radius-12 bg-white position-relative">
            <div class="body">
              <img src="/assets/images/icons/bolt-icon.svg" class="hw-70 mb-4" alt="">
              <h4 class="fs-24 fw-700 black-40 mb-3">
                Financing Confirmed!
              </h4>
              <p class="fs-16 fw-700 grey-65 mb-4">
                Your Financing has been successfully processed. Funds have been added to your next payout. No further action
                is needed.
              </p>
              <button class="btn btn-secondary fw-700 w-100" (click)="close()">
                {{fromPage == 'dashboard' ? 'Back To Dashboard' : 'Back To Details'}}
              </button>
            </div>
          </div>
        </ng-template>
